import React from 'react';
import { motion } from 'framer-motion';

const Logo = () => (
  <img 
    src="https://media-manager-c.questera.ai/greta-media/6f319949afba45b9008649532004af25bb95492e2b2fb555f5bdcdad5193a9e70a9e6d92944cfc73f8b57561372ade93/images/aW1hZ2UvcG5n/3fe35859a0b07eda876acbdc65469532.png" 
    alt="Étera Dragon House Logo" 
    className="w-24 h-24 md:w-32 md:h-32 mb-8 object-contain"
  />
);

export default function Hero() {
  const scrollToNewsletter = () => {
    const element = document.getElementById('newsletter');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="min-h-[80vh] w-full bg-etera-ivory flex flex-col items-center justify-center p-6 text-center overflow-hidden">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="flex flex-col items-center max-w-3xl mx-auto"
      >
        <Logo />
        
        <div className="flex flex-col items-center mb-10">
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-serif text-etera-black tracking-tight mb-4">
            ÉTERA
          </h1>
          <h2 className="text-sm md:text-base lg:text-lg uppercase tracking-[0.4em] text-etera-gold font-medium">
            Dragon House
          </h2>
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.8 }}
          className="font-serif italic text-xl md:text-2xl text-etera-charcoal mb-12 max-w-xl leading-relaxed"
        >
          "Muchas identidades, un mismo fuego."
        </motion.p>

        <motion.button
          onClick={scrollToNewsletter}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.5 }}
          className="group relative inline-flex items-center justify-center bg-etera-gold text-etera-black px-12 py-4 text-sm font-semibold tracking-widest uppercase overflow-hidden transition-all duration-300 hover:bg-etera-charcoal hover:text-etera-ivory"
        >
          <span className="relative z-10 transition-colors duration-300">
            ACCESO ANTICIPADO
          </span>
        </motion.button>
      </motion.div>
    </section>
  );
}